import { render, staticRenderFns } from "./QuestionnaireList.vue?vue&type=template&id=4fcd3dd8"
import script from "./QuestionnaireList.vue?vue&type=script&lang=js"
export * from "./QuestionnaireList.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireList.vue?vue&type=style&index=0&id=4fcd3dd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports